import api from "api/api";

export const newUserObjectivesQuery = async (data) =>
  await api.post(`/datatrack/objectives`, data);

export const updateUserObjectivesQuery = async (data) =>
  await api.patch(`/datatrack/objectives/`, data);

export const deleteUserObjectivesQuery = async (data) =>
  await api.delete(`/datatrack/objectives`, data);

export const getTeamMembers = async () =>
  await api.get(`/datatrack/objectives/members/`);

export const getObjectivesQuery = async ({ userScope }) =>
  await api.get(`/datatrack/objectives?scope=${userScope}`);

export const getObjectivesRealizedQuery = async ({
  userScope,
  year,
  branch_ids,
  manager_ids,
}) => {
  let url = `/datatrack/objectives/realized?scope=${userScope}&year=${year}`;

  if (branch_ids && branch_ids.length > 0) {
    url += `&branches=${branch_ids.join(",")}`;
  }

  if (manager_ids && manager_ids.length > 0) {
    url += `&managers=${manager_ids.join(",")}`;
  }

  return await api.get(url);
};

export const getObjectivesAndRealizedExportQuery = async ({
  scope,
  year,
  lang,
}) =>
  api.getBlob(
    `/datatrack/objectives/realized/export?scope=${scope}&year=${year}&lang=${lang}`
  );
